<div mat-dialog-title><h1>Reset Password</h1></div>

<div mat-dialog-content>
  <div class="content-container flex flex-col">

    <div class="grid grid-cols-12 gap-4">
      <div class="col-span-12">
      @if (data?.passwordInsecure) {
        <h3 class="text-lg">Your current password doesn't meet our updated security requirements. Please create a new password to continue.</h3>
      } @else {
        <h3 class="text-lg">Enter a new password.</h3>
      }
      </div>

      @if (hasError) {
        <div class="error-box reset-error col-span-12 justify-center items-center content-center">
          <label>
            {{errorMessage}}
          </label>
        </div>
      }

      <div class="col-span-4 flex items-center">
        <h3 class="text-base font-medium">Password *</h3>
      </div>

      <div class="col-span-8 flex flex-col">
        <app-password-input
          [(ngModel)]="password.value"
          (ngModelChange)="onPasswordChange($event)"
          [maxlength]="45"
          [minlength]="7"
          placeholder="enter new password">
        </app-password-input>
        @if (password.invalid) {
          <div class="error-message">{{getPasswordErrorMessage()}}</div>
        }
      </div>

      <div class="password-validation-container col-start-5 col-span-8 flex flex-col gap-2 mt-2 mb-4">
        <label class="font-medium mb-1"><strong>Password must include one of each:</strong></label>
        <div class="grid grid-cols-1">
          <div class="flex items-center gap-2 col-start-1">
            <app-valid-icon-toggle #uppercaseIcon [isValid]="criteria?.hasUppercase"></app-valid-icon-toggle>
            <span>One uppercase letter</span>
          </div>
          <div class="flex items-center gap-2 col-start-1">
            <app-valid-icon-toggle #lowercaseIcon [isValid]="criteria?.hasLowercase"></app-valid-icon-toggle>
            <span>One lowercase letter</span>
          </div>
          <div class="flex items-center gap-2 col-start-1">
            <app-valid-icon-toggle #numberIcon [isValid]="criteria?.hasNumber"></app-valid-icon-toggle>
            <span>One number</span>
          </div>
          <div class="flex items-center gap-2 col-start-1">
            <app-valid-icon-toggle #specialCharIcon [isValid]="criteria?.hasSpecialChar"></app-valid-icon-toggle>
            <span>One special character</span>
          </div>
          <div class="flex items-center gap-2 col-start-1">
            <app-valid-icon-toggle #lengthIcon [isValid]="criteria?.hasValidLength"></app-valid-icon-toggle>
            <span>7 to 45 characters</span>
          </div>
          <div class="flex items-center gap-2 col-start-1">
            <app-valid-icon-toggle #forbiddenWordIcon [isValid]="criteria?.hasNoForbiddenWords"></app-valid-icon-toggle>
            <span>Cannot contain restricted words</span>
          </div>
        </div>
      </div>

      <div class="col-span-4 flex items-center">
        <h3 class="text-base font-medium">Confirm Password *</h3>
      </div>

      <div class="col-span-8 flex flex-col">
        <app-password-input
          [(ngModel)]="confirmPassword.value"
          (ngModelChange)="onConfirmPasswordChange($event)"
          [maxlength]="45"
          [minlength]="7"
          placeholder="confirm new password">
        </app-password-input>
        @if (confirmPassword.invalid) {
          <div class="error-message">{{getconfirmPasswordErrorMessage()}}</div>
        }
      </div>
      </div>

    </div>
  </div>

  <div class="dialog-bottom-section flex flex-row">
    @if (orgPolicyDays >= 0) {
      <label class="flex basis-[50%] justify-start items-center content-center pr-[20px]">Organization policy requires a password reset every {{orgPolicyDays}} days.</label>
    }
    <div class="flex flex-auto justify-end items-end content-end gap-2">
      <button mat-flat-button class="secondary-button" (click)="onCancel()" [disabled]="isSubmitting">Cancel</button>
      <button
        mat-flat-button
        class="primary-button-longtext"
        [disabled]="!arePasswordCriteriaMet() || isSubmitting"
        (click)="resetPassword()">
        Save & Login
      </button>
    </div>
  </div>
